import ExternalLink from './ExternalLink';

export { ExternalLink };



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/uikit/Links/index.js